<script context="module" lang="ts">
  const drawerOpened = new PersistedState<boolean>('drawerOpened', false);
</script>

<script lang="ts">
  import MenuIcon from '~/icons/MenuIcon.svelte';
  import MenuHelpIcon from '~/icons/MenuHelpIcon.svelte';
  import Title from '~/Title.svelte';
  import { PersistedState } from 'runed';
  import { drawer } from '../Drawer.svelte';

  const handleOpen = () => {
    drawerOpened.current = true;
    drawer.push();
  };
</script>

<button class="menu-button" style="" on:click={handleOpen}>
  {#if !drawerOpened.current}
    <MenuHelpIcon size="24px" />
  {:else}
    <MenuIcon size="24px" />
  {/if}
  <Title />
</button>

<style lang="scss">
  @use 'sass:color';
  @use '~/theme/theme';

  .menu-button {
    position: absolute;
    transition: all 0.2s ease;
    text-decoration: none;
    color: currentColor;
    margin-top: -0.5em;
    margin-left: -0.5em;
    margin-bottom: 0;
    background: none;
    border: none;
    display: grid;
    grid-auto-flow: column;
    align-items: center;
    border-radius: 999px;
    gap: 0.5em;
    cursor: pointer;
    &:active {
      background-color: color.adjust(
        theme.$tile-default-light,
        $lightness: -20%
      );
      :global(html.dark-mode) & {
        background-color: color.adjust(
          theme.$tile-default-dark,
          $lightness: 20%
        );
      }
    }
    &:hover {
      background-color: color.adjust(
        theme.$tile-default-light,
        $lightness: -10%
      );
      :global(html.dark-mode) & {
        background-color: color.adjust(
          theme.$tile-default-dark,
          $lightness: 10%
        );
      }
    }
  }
</style>
